'use strict';

var _regeneratorRuntime = require("/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.define-properties");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.assign");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.map");

var _slicedToArray = require("/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.define-property");

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(modularScaleGen),
    _marked2 = /*#__PURE__*/_regeneratorRuntime.mark(linearScaleGen);

Object.defineProperty(exports, '__esModule', {
  value: true
});

var firstLeft = function firstLeft(arr, idx) {
  if (idx >= arr.length) idx = arr.length - 1;

  while (idx > -1 && (arr[idx] === null || arr[idx] === undefined)) {
    idx--;
  }

  return arr[idx];
};

var parsePropValue = function parsePropValue(value) {
  var isNegative = value[0] === '-';
  var baseValue = isNegative ? value.slice(1) : value;
  return [baseValue, isNegative];
};

var negate = function negate(v) {
  return typeof v === 'number' ? -v : '-' + v;
};

var parseProp = function parseProp(prop, theme, config) {
  var scale = theme[config.scale] || config.defaultScale;

  if (Array.isArray(prop)) {
    var result = [];
    var count = theme.breakpoints.length + 1;

    for (var i = 0; i < count; i++) {
      var _parsePropValue = parsePropValue(firstLeft(prop, i)),
          _parsePropValue2 = _slicedToArray(_parsePropValue, 2),
          _s = _parsePropValue2[0],
          _isNeg = _parsePropValue2[1];

      if (_s === undefined) return;
      result[i] = _isNeg ? negate(scale[_s][i]) : scale[_s][i];
    }

    return result;
  }

  var _parsePropValue3 = parsePropValue(prop),
      _parsePropValue4 = _slicedToArray(_parsePropValue3, 2),
      s = _parsePropValue4[0],
      isNeg = _parsePropValue4[1];

  if (s === undefined) return;
  return isNeg ? scale[s].map(negate) : scale[s];
};

var scales = function scales(configs) {
  var cache = {};

  var parse = function parse(props) {
    var propKeys = Object.keys(props);
    var systemProps = {};
    var theme = props.theme || {};

    for (var i = 0; i < propKeys.length; i++) {
      if (!(propKeys[i] in configs)) continue;
      var key = propKeys[i];
      var prop = props[key];
      var config = configs[key];
      var systemProp = config.systemProp;
      var val = parseProp(prop, theme, config);
      systemProps[systemProp] = val;
    }

    return Object.assign(systemProps, props);
  };

  parse.configs = configs;
  parse.cache = cache;
  return parse;
};

var composeScales = function composeScales() {
  var configs = {};

  for (var _len = arguments.length, parsers = new Array(_len), _key = 0; _key < _len; _key++) {
    parsers[_key] = arguments[_key];
  }

  for (var i = 0; i < parsers.length; i++) {
    Object.assign(configs, parsers[i].configs);
  }

  return scales(configs);
};

var interceptScales = function interceptScales(scaleParser) {
  return function (systemParser) {
    return function (props) {
      return systemParser(scaleParser(props));
    };
  };
};

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var _cssRegex = /^([+-]?(?:\d+|\d*\.\d+))([a-z]*|%)$/;

var _stripUnit = function _stripUnit(val, unitReturn) {
  if (typeof val !== 'string') return unitReturn ? [val, undefined] : val;
  var matchedValue = val.match(_cssRegex);

  if (unitReturn) {
    if (matchedValue) return [parseFloat(val), matchedValue[2]];
    return [val, undefined];
  }

  if (matchedValue) return parseFloat(val);
  return val;
}; // Generator function that returns an increasing modular scale value on each
// `next` call.


function modularScaleGen() {
  var i,
      r,
      p,
      j,
      _args = arguments;
  return _regeneratorRuntime.wrap(function modularScaleGen$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          i = _args.length > 0 && _args[0] !== undefined ? _args[0] : 0;
          r = _args.length > 1 && _args[1] !== undefined ? _args[1] : 2;
          p = _args.length > 2 && _args[2] !== undefined ? _args[2] : 100;
          j = 0;

        case 4:
          if (!true) {
            _context.next = 9;
            break;
          }

          _context.next = 7;
          return Math.round(p * Math.pow(r, j++)) / p + i;

        case 7:
          _context.next = 4;
          break;

        case 9:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
} // Generator function that returns an increasing linear scale value on each
// `next` call.


function linearScaleGen() {
  var i,
      r,
      p,
      j,
      _args2 = arguments;
  return _regeneratorRuntime.wrap(function linearScaleGen$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          i = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : 0;
          r = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : 1;
          p = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : 100;
          j = 0;

        case 4:
          if (!true) {
            _context2.next = 9;
            break;
          }

          _context2.next = 7;
          return Math.round(p * j++ * r) / p + i;

        case 7:
          _context2.next = 4;
          break;

        case 9:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
} // Returns a linear ratio given a min, max, and number of steps to get from min
// to max.


var linearRatio = function linearRatio(min, max) {
  var steps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return (max - min) / steps;
}; // Returns a scale using the provided scaling function.


var scale = function scale() {
  var count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var gen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : linearScaleGen();

  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref2$unit = _ref2.unit,
      unit = _ref2$unit === void 0 ? 0 : _ref2$unit,
      _ref2$min = _ref2.min,
      min = _ref2$min === void 0 ? -Infinity : _ref2$min,
      _ref2$max = _ref2.max,
      max = _ref2$max === void 0 ? Infinity : _ref2$max,
      _ref2$transform = _ref2.transform,
      transform = _ref2$transform === void 0 ? function (x) {
    return x;
  } : _ref2$transform;

  var arr = [];

  for (var i = 0; i < count; i++) {
    arr.push(Math.min(max, Math.max(min, transform(gen.next().value, i, count))) + unit);
  }

  return arr;
}; // Returns a linear scale.


var linearScale = function linearScale(min, max) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      count = _ref.count,
      ratio = _ref.ratio,
      precision = _ref.precision,
      unit = _ref.unit,
      opts = _objectWithoutProperties(_ref, ["count", "ratio", "precision", "unit"]);

  if (count && ratio) throw new Error('Count and ratio were provided, but only one can be defined.');

  var _stripUnit2 = _stripUnit(min, true),
      _stripUnit3 = _slicedToArray(_stripUnit2, 2),
      minV = _stripUnit3[0],
      minU = _stripUnit3[1];

  var _stripUnit4 = _stripUnit(max, true),
      _stripUnit5 = _slicedToArray(_stripUnit4, 2),
      maxV = _stripUnit5[0],
      maxU = _stripUnit5[1];

  if (!unit && minU !== maxU) throw new Error('Units of min and max do not match.');
  unit = unit || minU;

  if (count) {
    ratio = linearRatio(minV, maxV, count - 1);
  } else if (ratio) {
    count = (maxV - minV) / ratio + 1;
  } else {
    count = maxV - minV + 1;
    ratio = 1;
  }

  var gen = linearScaleGen(minV, ratio, precision);
  return scale(count, gen, _objectSpread2({
    unit: unit,
    min: minV,
    max: maxV
  }, opts));
}; // Negates all values of a scale. Maintains units.


var negateScale = function negateScale(scale) {
  return scale.map(function (x) {
    var _stripUnit6 = _stripUnit(x, true),
        _stripUnit7 = _slicedToArray(_stripUnit6, 2),
        v = _stripUnit7[0],
        unit = _stripUnit7[1];

    return -v + (unit || 0);
  });
}; // Adds two scales together. Maintains the unit of the left array. Unit of the
// right array is ignored.


var addScales = function addScales(a, b) {
  var _stripUnit8 = _stripUnit(a[0], true),
      _stripUnit9 = _slicedToArray(_stripUnit8, 2),
      unit = _stripUnit9[1];

  var result = [];

  for (var i = 0; i < a.length; i++) {
    result[i] = _stripUnit(a[i] || 0) + _stripUnit(b[i] || 0) + (unit || 0);
  }

  return result;
}; // Subtracts two scales. Maintains the unit of the left array. Unit of the
// right array is ignored.


var subtractScales = function subtractScales(a, b) {
  return addScales(a, negateScale(b));
}; // Merge scale values from the right scale into the left scale. An undefined
// value in the right scale falls back to the left scale value.


var mergeScalesLeft = function mergeScalesLeft(a, b) {
  var result = [];

  for (var i = 0; i < Math.max(a.length, b.length); i++) {
    result[i] = b[i] === undefined ? a[i] : b[i];
  }

  return result;
}; // Merge scale values from the left scale into the right scale. An undefined
// value in the left scale falls back to the right scale value.


var mergeScalesRight = function mergeScalesRight(a, b) {
  return mergeScalesLeft(b, a);
};

var configs = {
  gridGapScale: {
    systemProp: 'gridGap',
    scale: 'spaceScales'
  },
  gridColumnGapScale: {
    systemProp: 'gridColumnGap',
    scale: 'spaceScales'
  },
  gridRowGapScale: {
    systemProp: 'gridRowGap',
    scale: 'spaceScales'
  }
};
var gridScales = scales(configs);
var configs$1 = {
  topScale: {
    systemProp: 'top',
    scale: 'spaceScales'
  },
  rightScale: {
    systemProp: 'right',
    scale: 'spaceScales'
  },
  bottomScale: {
    systemProp: 'bottom',
    scale: 'spaceScales'
  },
  leftScale: {
    systemProp: 'left',
    scale: 'spaceScales'
  }
};
var positionScales = scales(configs$1);
var configs$2 = {};
configs$2.margin = {
  marginScale: {
    systemProp: 'm',
    scale: 'spaceScales'
  },
  marginTopScale: {
    systemProp: 'mt',
    scale: 'spaceScales'
  },
  marginRightScale: {
    systemProp: 'mr',
    scale: 'spaceScales'
  },
  marginBottomScale: {
    systemProp: 'mb',
    scale: 'spaceScales'
  },
  marginLeftScale: {
    systemProp: 'ml',
    scale: 'spaceScales'
  },
  marginXScale: {
    systemProp: 'mx',
    scale: 'spaceScales'
  },
  marginYScale: {
    systemProp: 'my',
    scale: 'spaceScales'
  }
};
configs$2.margin.mScale = configs$2.margin.marginScale;
configs$2.margin.mtScale = configs$2.margin.marginTopScale;
configs$2.margin.mrScale = configs$2.margin.marginRightScale;
configs$2.margin.mbScale = configs$2.margin.marginBottomScale;
configs$2.margin.mlScale = configs$2.margin.marginLeftScale;
configs$2.margin.mxScale = configs$2.margin.marginXScale;
configs$2.margin.myScale = configs$2.margin.marginYScale;
configs$2.padding = {
  paddingScale: {
    systemProp: 'p',
    scale: 'spaceScales'
  },
  paddingTopScale: {
    systemProp: 'pt',
    scale: 'spaceScales'
  },
  paddingRightScale: {
    systemProp: 'pr',
    scale: 'spaceScales'
  },
  paddingBottomScale: {
    systemProp: 'pb',
    scale: 'spaceScales'
  },
  paddingLeftScale: {
    systemProp: 'pl',
    scale: 'spaceScales'
  },
  paddingXScale: {
    systemProp: 'px',
    scale: 'spaceScales'
  },
  paddingYScale: {
    systemProp: 'py',
    scale: 'spaceScales'
  }
};
configs$2.padding.pScale = configs$2.padding.paddingScale;
configs$2.padding.ptScale = configs$2.padding.paddingTopScale;
configs$2.padding.prScale = configs$2.padding.paddingRightScale;
configs$2.padding.pbScale = configs$2.padding.paddingBottomScale;
configs$2.padding.plScale = configs$2.padding.paddingLeftScale;
configs$2.padding.pxScale = configs$2.padding.paddingXScale;
configs$2.padding.pyScale = configs$2.padding.paddingYScale;
var marginScales = scales(configs$2.margin);
var paddingScales = scales(configs$2.padding);
var spaceScales = scales(_objectSpread2({}, configs$2.margin, {}, configs$2.padding));
var configs$3 = {
  fontSizeScale: {
    systemProp: 'fontSize',
    scale: 'fontSizeScales'
  }
};
var typographyScales = scales(configs$3);
exports.addScales = addScales;
exports.composeScales = composeScales;
exports.gridScales = gridScales;
exports.interceptScales = interceptScales;
exports.linearRatio = linearRatio;
exports.linearScale = linearScale;
exports.linearScaleGen = linearScaleGen;
exports.mergeScalesLeft = mergeScalesLeft;
exports.mergeScalesRight = mergeScalesRight;
exports.modularScaleGen = modularScaleGen;
exports.negateScale = negateScale;
exports.positionScales = positionScales;
exports.scale = scale;
exports.scales = scales;
exports.spaceScales = spaceScales;
exports.subtractScales = subtractScales;
exports.typographyScales = typographyScales;